export { default, getServerSideProps } from './B2BLogin';
